var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('div',{staticClass:"not-found"},[_c('h1',[_vm._v("Not Found")]),_c('h5',[_vm._v("The requested page could not be found.")])])])}
var staticRenderFns = []

export { render, staticRenderFns }